import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Button, Stack } from '@mui/material';
import axios from 'api/axiosInstance';
import endpoints from 'api/endpoints';
import BookAppointmentModal from '../components/BookAppointment/BookAppointmentModal';

// Public, company-scoped walk-in registration page. The dashboard QR points
// here (/walk-in/:id). A patient scans it, registers, and gets a queue token —
// no login, no slot selection (BookAppointmentModal in offlineOnly mode).
export default function WalkInBooking() {
  const { id } = useParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!id) { setLoading(false); return; }
    (async () => {
      try {
        const resp = await axios.get(endpoints.company.getCompanyById(id));
        setCompany(resp.data);
      } catch {
        setCompany(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const name = company?.company_name || company?.name || 'Walk-in Registration';

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 3, bgcolor: '#F8FAFC' }}>
      <Stack spacing={2.5} alignItems="center" sx={{ textAlign: 'center', maxWidth: 480 }}>
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#0F766E' }}>{name}</Typography>
        <Typography color="text.secondary">
          Register as a walk-in patient and receive your queue token. No appointment slot needed.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => setOpen(true)}
          sx={{ bgcolor: '#0D9488', '&:hover': { bgcolor: '#0F766E' }, borderRadius: 2, px: 4, py: 1.25, textTransform: 'none', fontWeight: 700 }}
        >
          Register Walk-in
        </Button>
      </Stack>

      <BookAppointmentModal
        open={open}
        offlineOnly
        id={id}
        accentColor="#0D9488"
        onClose={() => setOpen(false)}
        onSuccess={() => {}}
      />
    </Box>
  );
}
